<nav class="navbar">
  <div class="container-fluid display-profile-header pl-20 pr-20 align-items-center">
    <div class="d-flex">
      <img alt="" class="side_logo_text_booking" src="assets/images/favicon/cc_reverse@2x.png" />
    </div>
    @if (!isAuthenticated) {
    <div class="nav-item public-profile d-flex align-items-center">
      <li class="nav-item">
        <a class="nav-link" target="_blank"
          href="https://www.classcover.com.au/teachers?utm_source=cc_app&amp;utm_campaign=jobs">Learn more</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" target="_blank"
          href="https://www.classcover.com.au/hire-teachers-through-classcover-jobs?utm_source=cc_app&amp;utm_campaign=jobs">Post
          a job</a>
      </li>
      <li class="nav-item pr-2">
        <a class="nav-link" target="_blank" href="https://qld-dev.classcover.com.au/login">Login</a>
      </li>
    </div>
    }
  </div>
</nav>
<div class="row pb-90 pt-90">
  <!-- First half -->
  <div class="col-lg-8 col-md-12 col-sm-12 col-12 mb-15">
    <div class="card px-15">
      <div class="row">
        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-10">
          <div class="align-items-center d-flex">
            <p class="wrapper">
              <img alt="" class="avatar" [src]="
                  profileData?.additional_info?.profile_image == null || profileData?.additional_info?.profile_image == ''
                    ? '../../../../assets/images/pro_avatar.png'
                    : profileData?.additional_info?.profile_image
                " />
            </p>
            <div class="ml-10">
              <p class="c-p ul-title">{{ profileData?.title }}</p>
              <p class="txt-regular mt-2">
                <i class="bi bi-geo-alt-fill"></i>
                {{ profileData?.address?.city }},
                {{ profileData?.address.address_timezone.state }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 col-2"></div>
      </div>
    </div>
    <!-- <div class="card px-15 mt-16">
      <div class="d-flex s_between align-items-center">
        <div class="d-flex">
          <h5 class=" ul-title mb-0">Video Introduction
          </h5>
          <span class="badge-new ml-10">New⚡</span>
        </div>

      </div>
      <ng-container *ngIf="introVideo?.id; else addVideoPrompt">
        <div class="row justify-content-center align-items-center text-center p-20">
          <div class="col-lg-12">
            <app-video-player [videoMeta]="introVideo"></app-video-player>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #addVideoPrompt>
      <p class="mt-20"> No introduction video added.</p>
    </ng-template> -->
    @if (profileData?.subscription?.job_only_school == false) {
    <div class="card px-15 mt-30">
      <div class="row">
        <div class="col-lg-10 col-md-10 col-sm-9 col-xs-9 col-9">
          <h5 class="ul-title">Overview</h5>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-3 col-xs-3 col-3"></div>
      </div>
      <div class="mt-5 txt-regular">
        <p class="mt-10 pre-line" [innerHTML]="profileData?.overview"></p>
      </div>
      <div class="mt-10">
        <div class="row align-items-center">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Size</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">
              {{ profileData?.subscription?.enrolment_size }} students
              <i class="bi bi-dot"></i>
              {{ profileData?.additional_info?.teachers_size }} staff
            </span>
          </div>
        </div>
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Type</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.subscription?.display_school_type }}</span>
          </div>
        </div>
        @if (schoolProps.properties.is_qld_teacher || schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer') {
        <!-- Region Name -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Region Name</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.additional_info?.region_name }}</span>
          </div>
        </div>
        }
        <!-- <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Contact</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular clr-pink">{{ profileData?.email }}</span>
            <span class="txt-regular">
              <i class="bi bi-dot"></i> {{ profileData?.phone_number }}</span>
          </div>
        </div> -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Principal name</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.additional_info?.school_principal_full_name }}</span>
          </div>
        </div>
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Gender</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.additional_info?.school_gender }}</span>
          </div>
        </div>
        @if (schoolProps.properties.is_qld_teacher || schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer') {
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School email address</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular clr-cc-vilot">{{ profileData?.email }}</span>
          </div>
        </div>
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Booking email address</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular clr-cc-vilot">{{ profileData?.additional_info?.booking_school_email }}</span>
          </div>
        </div>
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Contact officer</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.phone_number }}</span>
          </div>
        </div>
        }
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Website</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular clr-cc-vilot">{{ profileData?.additional_info?.school_website }}</span>
          </div>
        </div>
        <!-- <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">RTA Contact</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.rta_user?.user?.full_name }}
              <i class="bi bi-dot"></i>{{ profileData?.rta_user?.phone }}</span>
          </div>
        </div> -->
        @if (!schoolProps.properties.is_qld_teacher && !schoolProps.properties.is_qld_school) {
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School level</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.subscription?.school_level_display }}</span>
          </div>
        </div>
        }
        @if (schoolProps.properties.is_qld_teacher || schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer') {
        <!-- Long Day School -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Long Day School</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.admin_settings?.is_long_day_booking ? 'Yes' : 'No' }}</span>
          </div>
        </div>

        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Year Levels</div>
          </div>
          <div class="col-lg-8">
            <!-- Display year levels as a list if available -->
            <!-- <ul *ngIf="profileData?.additional_info?.yearLevel_option" class="d-flex flex-wrap txt-regular year-level-list">
              @for (year of profileData.additional_info.yearLevel_option; track year) {
                <li>{{ year }}</li>
              }
            </ul> -->
            <app-subject-chips [qualified]="profileData?.additional_info?.yearLevel_option"
              [title]="'School Year Levels'" [maxVisible]="10"></app-subject-chips>
          </div>
        </div>
        <!-- Address Line 1 -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">Address</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.address?.address_1 }}
                                                {{profileData?.address?.city}}
                                                {{profileData?.address?.address_timezone?.state}} -
                                                {{profileData?.address?.postal_code}}</span>
          </div>
        </div>
        <!-- School Hours- Start Time -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Hours- Start Time</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.admin_settings?.default_school_time?.full_day?.start_time
              }}</span>
          </div>
        </div>
        <!-- School Hours- End Time -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Hours- End Time</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.admin_settings?.default_school_time?.full_day?.end_time }}</span>
          </div>
        </div>
        <!-- School Hours- Hours -->
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Hours- Hours</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">{{ profileData?.admin_settings?.is_long_day_booking ? ' 07 hrs 30 mins ' : ' 05hrs 00 mins' }}</span>
          </div>
        </div>
        @if (schoolProps.properties.is_qld_teacher || schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer') {
        @if(profileData?.additional_info?.booking_cancel_casuals?.cancellation_email ||
        profileData?.additional_info?.booking_cancel_casuals?.cancellation_phone){
        <div class="mt-20">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div class="text-r-g-3">A/H Contact Officer</div>
            </div>
            <div class="col-lg-4">
              <div class="txt-regular">{{ profileData?.additional_info?.booking_cancel_casuals?.cancellation_email }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-20">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div class="text-r-g-3">A/H Phone</div>
            </div>
            <div class="col-lg-4">
              <div class="txt-regular">{{ profileData?.additional_info?.booking_cancel_casuals?.cancellation_phone }}
              </div>
            </div>
          </div>
        </div>
        }
        }
        }
      </div>
    </div>
    }
    @if (profileData?.subscription?.job_only_school == true) {
    <div class="card px-15 mt-30">
      <div class="row">
        <div class="col-lg-10 col-md-10 col-sm-9 col-xs-9 col-9">
          <h5 class="ul-title">Overview</h5>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-3 col-xs-3 col-3"></div>
      </div>
      <div class="mt-5 txt-regular">
        <p class="mt-10 pre-line" [innerHTML]="profileData?.overview"></p>
      </div>
      <div class="mt-10">
        <div class="row align-items-center">
          <div class="col-lg-4">
            <div class="text-r-g-3">School Size</div>
          </div>
          <div class="col-lg-8">
            <span class="txt-regular">
              {{ profileData?.subscription?.enrolment_size }} students
              <i class="bi bi-dot"></i>
              {{ profileData?.additional_info?.teachers_size }} staff
            </span>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div class="text-r-g-3">School Type</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular">{{ profileData?.subscription?.display_school_type }}</span>
            </div>
          </div>

          <div class="row align-items-center mt-20">
            <div class="col-lg-4">
              <div class="text-r-g-3">Principal</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular">{{ profileData?.additional_info?.school_principal_full_name }}</span>
            </div>
          </div>
          <div class="row align-items-center mt-20">
            <div class="col-lg-4">
              <div class="text-r-g-3">Gender</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular">{{ profileData?.additional_info?.school_gender }}</span>
            </div>
          </div>
          <div class="row align-items-center mt-20">
            <div class="col-lg-4">
              <div class="text-r-g-3">Website</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular clr-cc-vilot">{{ profileData?.additional_info?.school_website }}</span>
            </div>
          </div>
          <!-- <div class="row align-items-center mt-20">
            <div class="col-lg-4">
              <div class="text-r-g-3">RTA Contact</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular">{{ profileData?.rta_user?.user?.full_name }}
                <i class="bi bi-dot"></i>{{ profileData?.rta_user?.phone }}</span>
            </div>
          </div> -->
          <div class="row align-items-center mt-20">
            <div class="col-lg-4">
              <div class="text-r-g-3">School level</div>
            </div>
            <div class="col-lg-8">
              <span class="txt-regular">{{ profileData?.subscription?.school_level_display }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="card px-15 mt-16"
      *ngIf="profileData?.additional_info?.onboarding_documents?.length > 0 && from == 'my-school' && (schoolProps.properties.is_qld_teacher  || schoolProps.properties.is_qld_school  || schoolProps.properties.user_type == 'Tracer')">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-6">
          <h5 class="ul-title">Onboarding Documents</h5>
        </div>

      </div>
      <div class="mt-10">
        @for (
        documents of profileData?.additional_info
        ?.onboarding_documents; track
        documents; let i = $index) {
        <div class="row align-items-center mt-20">
          <div class="col-lg-4">
            <div class="text-r-g-3">{{ documents?.doc_type }}</div>
          </div>
          <div class="col-lg-4">
            <a href="{{ documents?.doc_url }}" target="_blank">
              <span class="txt-regular clr-cc-vilot">View Document <i class="bi bi-box-arrow-up-right"></i></span>
            </a>
          </div>
        </div>
        }
      </div>

    </div>
    <div class="card px-15 mt-16"
      *ngIf="profileData?.additional_info?.additional_information?.length > 0 && from == 'my-school' && (schoolProps.properties.is_qld_teacher  || schoolProps.properties.is_qld_school  || schoolProps.properties.user_type == 'Tracer')">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-6">
          <h5 class="ul-title">Additional Information</h5>
        </div>
        @for (
        additional_info of profileData?.additional_info
        ?.additional_information; track
        additional_info; let i = $index) {
        <div>
          <!-- @if ((schoolProps.properties.is_qld_teacher && i <
            profileData?.additional_info?.additional_information?.length) || i < 2) { <div class="row mt-20"> -->
          <div class="col-10">
            <p class="text-regular-medium">
              {{ additional_info?.title }}
            </p>
            <small class="text-r-g-3">{{ additional_info?.content }}</small>
          </div>
        </div>
        }
      </div>
      <!-- } -->
    </div>
  </div>

  <div class="card px-15 mt-30">
    <h5 class="ul-title mb-20">Location</h5>
    <div id="map" style="height: 380px;"></div>
  </div>
  <!-- Second Half -->
  @if (profileData?.subscription?.job_only_school == false) {
  <div class="col-lg-4 col-md-12 col-sm-12 col-12">
    @if (recentJobsList?.length > 0) {
    <div class="row">
      <div class="col-12">
        <div class="card px-15">
          <h4 class="ul-title">Recent Jobs Posted</h4>
          @for (job of recentJobsList; track job; let i = $index) {
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 c-p" (click)="openPublicJobs(job.id)">
              <h6 class="pt-3 mb-4 user-title">
                {{ job?.job_title }}
                <span class="qualified-in mt-5 bg-tags p-2 ml-6">{{ job?.job_type_display }}</span>
              </h6>
              <small class="txt-regular">
                {{ job?.job_title }}
                <i class="bi bi-dot"></i>
                {{ job?.school_level_display }}
              </small>
              <br />
              <small class="text-r-g-3">
                <i class="bi bi-geo-alt-fill bi-geo-alt-fill-public"></i>
                {{ job?.location }}
              </small>
            </div>
            <hr class="mt-8 mb-8" />
          </div>
          }
          <p class="c-p clr-cc-vilot text-center user-title mt-5 mb-10">
            View all
            <i class="bi bi-arrow-up-right"></i>
          </p>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>